export { GeneralInfo } from "./GeneralInfo"
